module.exports = __webpack_public_path__ + "img/guide_etudiant-vignette.f243f20c.png";